import { type Cart } from "@client/content/modules/Cart/types";
import { OrderItemLine } from "@client/content/modules/OrderConfirmation/Content/component";
import { formatMoneyDisplay } from "@client/lib/format";
import { useI18n } from "@common/hooks/i18n";
import { capitalize } from "lodash";
import * as React from "react";

type Props = {
  doesRequireShipping: boolean;
  isConfirmation: boolean;
  currencyCode: string;
  isEstimatedTax: boolean;
  totals: Cart.Api.Totals;
};
const OrderTotals = (props: Props) => {
  const i18n = useI18n();

  return (
    <div className="wsc_order_totals">
      <div className="detail">
        {!!props.totals.subtotalAmount && (
          <OrderItemLine name={i18n.subtotal} qa="Subtotal">
            {formatMoneyDisplay(props.totals.subtotalAmount, props.currencyCode)}
          </OrderItemLine>
        )}
        {props.doesRequireShipping && (
          <OrderItemLine name={i18n.shipping} qa="Shipping">
            {formatMoneyDisplay(props.totals.shippingAmount, props.currencyCode)}
          </OrderItemLine>
        )}

        {props.totals.surcharges
          .filter((x) => x.amount)
          .map((x) => (
            <OrderItemLine key={x.name} name={x.name} qa={capitalize(x.name)}>
              {formatMoneyDisplay(x.amount, props.currencyCode)}
            </OrderItemLine>
          ))}

        {!!props.totals.taxTotalAmount && (
          <OrderItemLine
            name={props.isEstimatedTax ? i18n.estimatedTax : i18n.tax}
            qa={props.isEstimatedTax ? "Estimated tax" : "Tax"}
          >
            {formatMoneyDisplay(props.totals.taxTotalAmount, props.currencyCode)}
          </OrderItemLine>
        )}
      </div>

      <div className="separator" />

      <div className="detail">
        {!!props.totals.voucherAmount && (
          <OrderItemLine name={i18n.voucher} qa="Voucher">
            {formatMoneyDisplay(props.totals.voucherAmount, props.currencyCode)}
          </OrderItemLine>
        )}
        {!!props.totals.discountAmount && (
          <OrderItemLine name={i18n.savings} qa="Savings">
            {props.totals.discountAmount > 0 ? "-" : ""}
            {formatMoneyDisplay(props.totals.discountAmount, props.currencyCode)}
          </OrderItemLine>
        )}

        <OrderItemLine className="total" name={i18n.total} qa="Total">
          {formatMoneyDisplay(
            props.isConfirmation ? props.totals.totalAmount : props.totals.dueAmount,
            props.currencyCode
          )}
        </OrderItemLine>

        {props.isConfirmation && (
          <>
            <OrderItemLine name={i18n.paid} qa="Paid">
              {formatMoneyDisplay(props.totals.paidAmount, props.currencyCode)}
            </OrderItemLine>

            <OrderItemLine name={i18n.due} qa="Amount">
              {formatMoneyDisplay(props.totals.dueAmount, props.currencyCode)}
            </OrderItemLine>
          </>
        )}
      </div>
    </div>
  );
};
export default OrderTotals;
